<template>
  <div class="accordion-wrap">
    <ul class="accordion-list">
      <li class="item parnet-item" v-for="(theme, index) in themes"
        :key="index"
      >
        <div class="parent-item-wrap">
          <button type="button" class="plus-btn mr-1 js-accordion-toggle" @click="showChildren(index, 'show')">＋</button>
          <v-checkbox
            :input-value="theme.isAllSelected"
            @change="setTheme(index, 'checkAll')"
            color="secondary"
            :label="theme.text"
            hide-details
            dense
            style="max-height: 35px"
          />
        </div>
        <ul class="child-list" v-if="theme.isShow">
          <li class="item child-item" v-for="(child, childIndex) in theme.children"
            :key="childIndex"
          >
            <v-checkbox
              color="secondary"
              :label="child.text"
              :input-value="child.checked"
              @change="setTheme(index, 'check', childIndex)"
              hide-details
              dense
            />
          </li>
        </ul>
      </li>
    </ul>

  </div>
</template>

<script>
export default {

  data: () => ({
  }),

  watch: {
  },

  computed: {
    themes() {
      return this.$store.state.conditions.selectedQuestionRangeTheme
    },
  },

  methods: {
    showChildren(index) {
      this.$store.commit('conditions/setSelectedQuestionRangeTheme', {
        index: index,
        params: {
          isShow: !this.themes[index].isShow
        }
      })
    },

    setTheme(index, mode, childIndex = null) {
      let show = this.themes[index].isShow
      let isAllSelected = this.themes[index].isAllSelected
      if(mode === 'checkAll') isAllSelected = !this.themes[index].isAllSelected     //isAllSelectedを切り替える
      const themeData = {
        index: index,
        mode: mode,
        params: {
          isShow: show,
          isAllSelected: isAllSelected,
        }
      }
      if(mode === 'check') {
        themeData.childIndex = childIndex,
        themeData.checked = !this.themes[index].children[childIndex].checked
      }
      this.$store.commit('conditions/setSelectedQuestionRangeTheme', themeData)
    },
  }
}
</script>

<style lang="stylus" scoped>
  .allotaion-area
    width 200px

  .flexbox
    display: flex;
    flex-wrap: nowrap;

  .accordion-wrap
    width: 500px;
    height: 300px;
    overflow-x: hidden;
    overflow-y: scroll;

  .accordion-list
    list-style-type: none;
    padding: 0;

  .accordion-list .v-input--selection-controls
    margin-top: 0;

  .accordion-list .parent-item
    border-bottom: 1px solid #ccc;

  .parent-item-wrap
    background: #efefef;
    padding: 1em 0 1em 1em;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-end;

  .accordion-list .item
    border-bottom: 1px solid #ccc;

  .child-list
    list-style-type: none;
    padding: 0;

  .child-list.is_open
    height: auto;
    opacity: 1;

  .child-item
    padding: 5px 0 5px 2.95em;

  .plus-btn
    box-sizing: border-box;
    font-weight bold
    text-align center
    padding 2px 0;
    margin: 0;
    width: 2em;
    border-radius 3px
    cursor pointer
    position relative
    position: relative;
    color: #fff;
    background-color: #aaa;
    font-size: 0.8em;

</style>
